import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import presendCodeReducer from '../../store/resendCode';

const { actions } = presendCodeReducer;

/**
 * useResendCode Custom Hook
 */
const useResendCode: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { resendCode } = state;

	// List of Actions
	const {
		handleResendCode		 
	} = actions;

	// Bind Actions
	const resendCodeActions = bindActions({
		handleResendCode		 
	}, dispatch);

	return { resendCode, ...resendCodeActions };
}

export default useResendCode;
